import { InjectionToken } from '@angular/core';

export const defaultErrors = {
    required: (error) =>  `APPLICATION.FRONT_OFFICE.ERRORI.RICHIESTO`, //`This field is required`,
    email: (error) =>  `Mail non valida`, //`This field is required`,
    minlength: ({ requiredLength, actualLength }) => `Expect ${requiredLength} but got ${actualLength}`,
    maxlength: ({ requiredLength, actualLength }) => `APPLICATION.FRONT_OFFICE.ERRORI.MAXLENGTH@${requiredLength}`, //`Expect ${requiredLength} but got ${actualLength}`,
    pattern : ( error) => `Il campo non è corretto`,
    cfnotvalid: ( error ) => `APPLICATION.FRONT_OFFICE.ERRORI.COD_FISC_DATA_NOT_VALID`,
    cognomecfnotvalid: ( error ) => `Il cognome inserito non corrisponde al Codice Fiscale`,
    nomecfnotvalid: ( error ) => `Il nome inserito non corrisponde al Codice Fiscale`,
    sessocfnotvalid: ( error ) => `Il sesso inserito non corrisponde al Codice Fiscale`,
    confmailnotvalid: ( error ) => `Email non corrisponde`,
    minorenotvalid: ( error ) => `La data inserita non corrisponde ad un minore`,
    birthnotvalid: (error) => `Data di nascita non valida`,
    custom : (err) => err
}

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
    providedIn: 'root',
    factory: () => defaultErrors
});
